import { lt } from '@mews/framework';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { getFullName } from '@mews-commander/utils';
import { PaymentLinkDetailItem } from './PaymentLinkDetailItem';

export const OwnerInfoRow = ({ accountId }: { accountId: string }) => {
    const {
        data: { customer, company },
    } = useRepositorySuspenseQuery(
        'accounts',
        'getAll',
        { accountIds: [accountId] },
        { select: (data) => ({ customer: data.customers?.[0], company: data.companies?.[0] }) }
    );

    const infoItem = company ? company.name : getFullName(customer);

    return <PaymentLinkDetailItem description={lt('Owner')} value={infoItem} />;
};
